export const DropDownLog =  ()=>{
    return (
                <li className="dropdown">
            <a href="/tcgcreatoreternalbetaver2/log" className="dropdown-item">ログ</a>
            </li>

    )
}
